/**
 * Load Google Ads event listeners
 * */

// view_item_list event
pmw.bus.on("pmw:pixel:view-item-list", (payload) => {

	try {
		if (!pmw.shouldFireBrowserPixel(payload, "google_ads")) return;

		// Get Google Ads data from the unified payload structure
		const googleAdsData = payload.pixels?.google_ads;

		if (!googleAdsData) {
			return;
		}

		pmw.gtagLoaded().then(() => {
			gtag("event", "view_item_list", googleAdsData);
			pmw.console.log("Google Ads: view_item_list event sent", googleAdsData);
		}).catch(pmw.gtagNotLoaded("Google Ads: view_item_list"));
	} catch (e) {
		console.error(e);
	}
});

// add_to_cart event
pmw.bus.on("pmw:pixel:add-to-cart", (payload) => {

	try {
		if (!pmw.shouldFireBrowserPixel(payload, "google_ads")) return;

		// Get Google Ads data from the unified payload structure
		const googleAdsData = payload.pixels?.google_ads;

		if (!googleAdsData) {
			return;
		}

		pmw.gtagLoaded().then(() => {
			gtag("event", "add_to_cart", googleAdsData);
			pmw.console.log("Google Ads: add_to_cart event sent", googleAdsData);
		}).catch(pmw.gtagNotLoaded("Google Ads: add_to_cart"));
	} catch (e) {
		console.error(e);
	}
});

// view_item event
pmw.bus.on("pmw:pixel:view-item", (payload) => {

	try {
		if (!pmw.shouldFireBrowserPixel(payload, "google_ads")) return;

		// Get Google Ads data from the unified payload structure
		const googleAdsData = payload.pixels?.google_ads;

		if (!googleAdsData) {
			return;
		}

		pmw.gtagLoaded().then(() => {
			gtag("event", "view_item", googleAdsData);
			pmw.console.log("Google Ads: view_item event sent", googleAdsData);
		}).catch(pmw.gtagNotLoaded("Google Ads: view_item"));
	} catch (e) {
		console.error(e);
	}
});


// view search event
pmw.bus.on("pmw:pixel:search", (payload) => {

	try {
		if (!pmw.shouldFireBrowserPixel(payload, "google_ads")) return;

		// Get Google Ads data from the unified payload structure
		const googleAdsData = payload.pixels?.google_ads;

		if (!googleAdsData) {
			return;
		}

		pmw.gtagLoaded().then(() => {
			gtag("event", "view_search_results", googleAdsData);
			pmw.console.log("Google Ads: view_search_results event sent", googleAdsData);
		}).catch(pmw.gtagNotLoaded("Google Ads: view_search_results"));
	} catch (e) {
		console.error(e);
	}
});


// user log in event
pmw.bus.on("pmw:pixel:login", () => {

	try {
		if (pmw.isEmptyObject(pmwDataLayer?.pixels?.google?.ads?.conversion_ids)) return;
		if (!pmw.googleConfigConditionsMet({type: "marketing"})) return;

		let data = {
			send_to: pmw.getGoogleAdsConversionIdentifiers(),
		};

		if (pmwDataLayer?.user?.id?.raw) {
			data.user_id = pmwDataLayer.user.id.raw;
		}

		pmw.gtagLoaded().then(() => {
			gtag("event", "login", data);
			pmw.console.log("Google Ads: login event sent", data);
		}).catch(pmw.gtagNotLoaded("Google Ads: login"));
	} catch (e) {
		console.error(e);
	}
});

/**
 * Google Ads remarketing purchase
 *
 * https://support.google.com/google-ads/answer/7305793
 */
pmw.bus.on("pmw:pixel:purchase", () => {

	try {
		if (pmw.isEmptyObject(pmw.getGoogleAdsConversionIdentifiersWithLabel())) return;
		if (!pmw.googleConfigConditionsMet({type: "marketing"})) return;

		let data = {
			send_to: pmw.getGoogleAdsConversionIdentifiers(),
			value  : pmwDataLayer.order.value.marketing,
			// currency: pmwDataLayer.order.currency,
			items: pmw.getGoogleAdsRegularOrderItems(),
		};

		pmw.gtagLoaded().then(() => {
			gtag("event", "purchase", data);
			pmw.console.log("Google Ads: purchase event sent (for remarketing lists)", data);
		}).catch(pmw.gtagNotLoaded("Google Ads: purchase (for remarketing lists)"));

	} catch (e) {
		console.error(e);
	}
});

/**
 * Google Ads conversion event
 *
 * new_customer parameter: https://support.google.com/google-ads/answer/9917012
 * cart data: https://support.google.com/google-ads/answer/9028614
 * customer_lifetime_value is undocumented, but available in gtag.js
 */
pmw.bus.on("pmw:pixel:purchase", () => {

	try {
		if (pmw.isEmptyObject(pmw.getGoogleAdsConversionIdentifiersWithLabel())) return;
		if (!pmw.googleConfigConditionsMet({type: "marketing"})) return;

		let data = {
			send_to       : pmw.getGoogleAdsConversionIdentifiersWithLabel(),
			transaction_id: pmwDataLayer.order.number,
			value         : pmwDataLayer.order.value.marketing,
			currency      : pmwDataLayer.order.currency,
			new_customer  : pmwDataLayer.order.new_customer,
		};

		if (pmwDataLayer?.order?.value?.ltv?.marketing) {
			data.customer_lifetime_value = pmwDataLayer.order.value.ltv.marketing;
		}

		if (pmwDataLayer?.user?.id?.raw) {
			data.user_id = pmwDataLayer.user.id.raw;
		}

		// https://support.google.com/google-ads/answer/9028614
		if (pmwDataLayer?.order?.aw_merchant_id) {
			data.discount         = pmwDataLayer.order.discount;
			data.aw_merchant_id   = pmwDataLayer.order.aw_merchant_id;
			data.aw_feed_country  = pmwDataLayer.order.aw_feed_country;
			data.aw_feed_language = pmwDataLayer.order.aw_feed_language;
			data.items            = pmw.getGoogleAdsRegularOrderItems();
		}

		// Add custom variables
		if (pmwDataLayer?.order?.google?.ads?.custom_variables) {
			Object.entries(pmwDataLayer.order.google.ads.custom_variables).forEach(([key, value]) => {
				data[key] = value;
			});
		}

		pmw.gtagLoaded().then(() => {
			// Attach the enhanced conversion user data before the conversion is queued.
			// On the order confirmation page this already happened while the tag was
			// set up. On the Automatic Conversion Recovery path the order only arrives
			// afterwards, so this is the point where the data becomes available.
			pmw.setGoogleEnhancedConversionData();

			// Event needs to be "purchase" (not "conversion") in order to be able to track cart data:
			// https://support.google.com/google-ads/answer/9028614
			gtag("event", "purchase", data);
			pmw.console.log("Google Ads: conversion event sent", data);
		}).catch(pmw.gtagNotLoaded("Google Ads: conversion"));

	} catch (e) {
		console.error(e);
	}
});
